import { useQuery } from '@tanstack/react-query';
import apiClient from 'services/apiClient';
import moment from 'moment';
import { REFERRAL_KEY_PREFIX } from "./useReferral";

export const referralEarningsKey = (affID, year) => [...REFERRAL_KEY_PREFIX, "refEarnings", affID, year];

const useReferralEarnings = (affID, year) => {
    const isCurrentYear = year === moment().year();
    const endPoint = affID > 0 
        ? `/Statistics/SubAffiliate/${affID}/Monthly`
        : `/Statistics/SubAffiliate/Monthly`
    const params = affID > 0 ? {Year: year, AffiliateID: affID} : {Year: year};

    return useQuery(
        referralEarningsKey(affID, year),
        () => apiClient.get(endPoint, { params: params }).then(r => r.data),
        { staleTime: isCurrentYear ? 5 * 60 * 1000 : Infinity }
    )
};

export default useReferralEarnings;